import { theme } from '../../global/_theme'

export const tripleStripsBaseSize = [1200, 1000]

export const tripleStripsPreset = [
  {
    color: theme.quaternary.base,
    animate: true,
    offset: 0,
    coordinates: [
      { x: 0, y: 1000 },
      { x: 1000, y: 0 }
    ]
  },
  {
    color: theme.secondary.base,
    animate: true,
    offset: 200,
    coordinates: [
      { x: 100, y: 1000 },
      { x: 1100, y: 0 }
    ]
  },
  {
    color: theme.tertiary.base,
    animate: true,
    offset: 400,
    coordinates: [
      { x: 200, y: 1000 },
      { x: 1200, y: 0 }
    ]
  }
]
